<div class="min-h-screen bg-gray-50 flex">
  @if(isLoading){
    <app-loader></app-loader>
  }

  <!-- Left Side - Header + Form -->
  <div class="flex-1 flex flex-col">
    <app-logo-header></app-logo-header>

    <div class="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div class="max-w-md w-full space-y-8">
        <!-- Logo -->
        <div class="text-center flex justify-center">
          <a routerLink="/">
            <img
              [src]="assetUrl + 'icons/gloget_logo-trans.png'"
              class="w-[96px] min-w-[96px]"
              alt="Glo logo"
            />
          </a>
        </div>

        <!-- Progress Indicator -->
        <div class="flex items-center justify-center space-x-4 mb-8">
          <div class="flex items-center">
            <div
              [ngClass]="currentStep >= 1 ? 'w-8 h-8 bg-gray-950 text-white rounded-full flex items-center justify-center text-sm font-medium' : 'w-8 h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-sm font-medium'">
              1
            </div>
            <span
              class="ml-2 text-sm font-medium"
              [ngClass]="currentStep >= 1 ? 'text-gray-950' : 'text-gray-500'"
            >
              Personal Info
            </span>
          </div>

          <div class="w-8 h-px bg-gray-300"></div>

          <div class="flex items-center">
            <div
              [ngClass]="currentStep >= 2 ? 'w-8 h-8 bg-gray-950 text-white rounded-full flex items-center justify-center text-sm font-medium' : 'w-8 h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-sm font-medium'">
              2
            </div>
            <span
              class="ml-2 text-sm font-medium"
              [ngClass]="currentStep >= 2 ? 'text-gray-950' : 'text-gray-500'"
            >
              Business Info
            </span>
          </div>
        </div>

        <!-- Step 1 Form -->
        <div *ngIf="currentStep === 1">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-900">Create Account</h2>
            <p class="mt-2 text-gray-600">Join as a Business Owner</p>
          </div>

          <form [formGroup]="step1Form" (ngSubmit)="onStep1Submit()" class="space-y-6">
            <div>
              <div class="floating-input">
                <input
                  id="full_name"
                  type="text"
                  formControlName="full_name"
                  class="w-full px-4 py-3 border border-gray-300 rounded-3xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder=" "
                />
                <label
                  for="full_name"
                  class="absolute left-4 top-[18px] text-gray-700 transition-all duration-300 pointer-events-none bg-white px-1 -mt-2 text-md"
                >
                  Full Name
                </label>
              </div>

              <div
                *ngIf="step1Form.get('full_name')?.invalid && step1Form.get('full_name')?.touched"
                class="mt-1 text-sm text-red-600"
              >
                {{ getFieldError(step1Form, 'full_name') }}
              </div>
            </div>

            <div>
              <div class="floating-input">
                <input
                  id="email"
                  type="email"
                  formControlName="email"
                  class="w-full px-4 py-3 border border-gray-300 rounded-3xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder=" "
                />
                <label
                  for="email"
                  class="absolute left-4 top-[18px] text-gray-700 transition-all duration-300 pointer-events-none bg-white px-1 -mt-2 text-md"
                >
                  Email Address
                </label>
              </div>

              <div
                *ngIf="step1Form.get('email')?.invalid && step1Form.get('email')?.touched"
                class="mt-1 text-sm text-red-600"
              >
                {{ getFieldError(step1Form, 'email') }}
              </div>
            </div>

            <div>
              <div class="floating-input">
                <input
                  id="password"
                  [type]="passwordVisible ? 'text' : 'password'"
                  formControlName="password"
                  class="w-full px-4 py-3 border border-gray-300 rounded-3xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder=" "
                />
                <label
                  for="password"
                  class="absolute left-4 top-[18px] text-gray-700 transition-all duration-300 pointer-events-none bg-white px-1 -mt-2 text-md"
                >
                  Password
                </label>

                <button
                  type="button"
                  (click)="toggleVisibility()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  <svg
                    *ngIf="!passwordVisible"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <svg
                    *ngIf="passwordVisible"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.3-4.2M6.423 6.423A9.953 9.953 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.956 9.956 0 01-1.23 2.57M15 12a3 3 0 01-4.874 2.316M3 3l18 18"
                    />
                  </svg>
                </button>
              </div>

              <div
                *ngIf="step1Form.get('password')?.invalid && step1Form.get('password')?.touched"
                class="mt-1 text-sm text-red-600"
              >
                {{ getFieldError(step1Form, 'password') }}
              </div>
              <p class="mt-1 text-xs text-gray-500">Must be at least 8 characters.</p>
            </div>

            <div>
              <div class="floating-input">
                <input
                  id="confirmPassword"
                  [type]="passwordConfirmVisible ? 'text' : 'password'"
                  formControlName="confirmPassword"
                  class="w-full px-4 py-3 border border-gray-300 rounded-3xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder=" "
                />
                <label
                  for="confirmPassword"
                  class="absolute left-4 top-[18px] text-gray-700 transition-all duration-300 pointer-events-none bg-white px-1 -mt-2 text-md"
                >
                  Confirm Password
                </label>

                <button
                  type="button"
                  (click)="toggleConfirmVisibility()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  <svg
                    *ngIf="!passwordConfirmVisible"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  <svg
                    *ngIf="passwordConfirmVisible"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.3-4.2M6.423 6.423A9.953 9.953 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.956 9.956 0 01-1.23 2.57M15 12a3 3 0 01-4.874 2.316M3 3l18 18"
                    />
                  </svg>
                </button>
              </div>

              <div
                *ngIf="step1Form.get('confirmPassword')?.invalid && step1Form.get('confirmPassword')?.touched"
                class="mt-1 text-sm text-red-600"
              >
                {{ getFieldError(step1Form, 'confirmPassword') }}
              </div>
              <div *ngIf="getFormError(step1Form)" class="mt-1 text-sm text-red-600">
                {{ getFormError(step1Form) }}
              </div>
            </div>

            <button
              type="button"
              class="px-6 py-2 shadow bg-gray-950 text-white rounded-3xl"
              (click)="onStep1Submit()"
            >
              Next
            </button>

            <div class="text-center">
              <p class="text-sm text-gray-600">
                Already have an account?
                <a
                  routerLink="/login"
                  (click)="navigateToBusinessLogin()"
                  class="font-medium text-gray-900 hover:text-gray-800 font-semibold"
                >
                  Log in here
                </a>
              </p>
            </div>
          </form>
        </div>

        <!-- Step 2 Form -->
        <div *ngIf="currentStep === 2">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-900">Business Details</h2>
            <p class="mt-2 text-gray-600">Tell us about your business</p>
          </div>

          <form [formGroup]="step2Form" (ngSubmit)="onStep2Submit()" class="space-y-6">
            <div>
              <div class="floating-input">
                <input
                  id="business_name"
                  type="text"
                  formControlName="business_name"
                  class="w-full px-4 py-3 border border-gray-300 rounded-3xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder=" "
                />
                <label
                  for="business_name"
                  class="absolute left-4 top-[18px] text-gray-700 transition-all duration-300 pointer-events-none bg-white px-1 -mt-2 text-md"
                >
                  Business Name
                </label>
              </div>
              <div
                *ngIf="step2Form.get('business_name')?.invalid && step2Form.get('business_name')?.touched"
                class="mt-1 text-sm text-red-600"
              >
                {{ getFieldError(step2Form, 'business_name') }}
              </div>
            </div>

            <div>
              <div class="floating-input">
                <select
                  id="business_type"
                  formControlName="business_type"
                  class="w-full px-4 py-3 border border-gray-300 appearance-none rounded-3xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all bg-white"
                >
                  <option value="" disabled>Select your business type</option>
                  <option value="hair_salon">Hair Salon</option>
                  <option value="nail_salon">Nail Salon</option>
                  <option value="beauty_salon">Beauty Salon</option>
                  <option value="body_wellness">Body & Wellness</option>
                  <option value="heair_removal">Hair Removal</option>
                  <option value="permanent_beauty">Permanent Beauty</option>
                  <option value="multi_service">Multi Service</option>
                </select>
                <label
                  for="business_type"
                  class="absolute left-4 top-[18px] text-gray-700 transition-all duration-300 pointer-events-none bg-white px-1 -mt-2 text-md"
                >
                  Business Type
                </label>
              </div>
              <div
                *ngIf="step2Form.get('business_type')?.invalid && step2Form.get('business_type')?.touched"
                class="mt-1 text-sm text-red-600"
              >
                {{ getFieldError(step2Form, 'business_type') }}
              </div>
            </div>

            <div class="flex space-x-4">
              <button
                type="button"
                (click)="goBackToStep1()"
                [disabled]="isLoading"
                [ngClass]="isLoading ? 
                  'flex-1 bg-gray-100 text-gray-400 py-3 px-4 rounded-3xl font-medium cursor-not-allowed' : 
                  'flex-1 bg-gray-200 text-gray-800 py-3 px-4 rounded-3xl font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors'"
              >
                Back
              </button>

              <button
                type="submit"
                [disabled]="isLoading"
                [ngClass]="isLoading ? 
                  'flex-1 bg-green-400 text-white py-3 px-4 rounded-3xl font-medium cursor-not-allowed flex items-center justify-center' : 
                  'flex-1 bg-gray-950 text-white py-3 px-4 rounded-3xl font-medium hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors flex items-center justify-center'"
              >
                <svg
                  *ngIf="isLoading"
                  class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  >
                  </path>
                </svg>
                {{ isLoading ? 'Creating Account...' : 'Create Account' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side - Image/Promotional Content -->
  <div
    class="hidden md:flex relative w-1/2 justify-center items-end bg-cover bg-center text-white p-10"
    [style.background-image]="'url(' + assetUrl + 'img/login-img.jpg)'"
  >
    <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-0"></div>
    <div class="w-full max-w-[600px] relative z-10">
      <div class="flex w-full items-start pb-4">
        <img [src]="assetUrl + 'icons/Star.png'" />
      </div>
      <h2 class="text-6xl mb-4 text-white">
        Effortless Beauty, One Click Away
      </h2>
      <p class="mb-6 text-lg text-white">
        Create a free account and get full access to all features for 30-days.
        No credit card needed. Get started in 2 minutes.
      </p>
      <div class="flex items-center text-md">
        <div class="flex mr-2">
          <img [src]="assetUrl + 'img/avatars.png'" />
        </div>
        <div class="flex flex-col items-center gap-1">
          <span class="flex items-center text-white">
            <img [src]="assetUrl + 'icons/5stars.svg'" class="pr-2 h-5" />
            <span class="text-white pt-1">5.0</span>
          </span>
          <span class="text-white">from 200+ reviews</span>
        </div>
      </div>
    </div>
  </div>
</div>